import {isEmpty} from "../Utils";
import React, {useContext, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleModal} from "../../actions/modal.action";
import {MyContext} from "../../contexts/MyContext";
import {useHistory} from "react-router-dom";

const AddFavorite = ({video}) => {
    const { rootState, addToVideoFavorite } = useContext(MyContext);
    const { isAuth } = rootState;
    const translations = useSelector(
        (state) => state.langReducer.translationsReducer.translate
    );
    const history = useHistory();
    const dispatch = useDispatch()
    const [inFavorite, setInFavorite] = useState(0);

    useEffect(() => {
        setInFavorite(parseInt(video.in_favorite));
    }, [video?.in_favorite]);

    const handleFavorite = (status) => {

        const setFavorite = async () => {
            if (isAuth) {
                await addToVideoFavorite(video?.id)
                    .then((res) => {
                        if (res.result === "ok") {
                            setInFavorite(status);
                            let text;
                            if (status) {
                                text = translations && !isEmpty(translations["video_added_to_list"])
                                    ? translations["video_added_to_list"]
                                    : "Your video has been added to your list!"
                            } else {
                                text = translations && !isEmpty(translations["video_removed_from_list"])
                                    ? translations["video_removed_from_list"]
                                    : "Your video has been removed from your list!"
                            }

                            dispatch(toggleModal(
                                {
                                    opened: true,
                                    success: true,
                                    text: text
                                })
                            )
                        }
                    })
            } else {
                history.push("/account/login");
            }
        };

        setFavorite();
    };

    return (
        <button className={`button button-blue ${inFavorite > 0 ? "minus" : "plus"}`} onClick={() => handleFavorite(!inFavorite)}
        >{inFavorite > 0 ? (
            translations && !isEmpty(translations["remove_list"])
                ? translations["remove_list"]
                : "remove_list"
        ) : (
            translations && !isEmpty(translations["add_list"])
                ? translations["add_list"]
                : "add_list"
        )}</button>
    )
}

export default AddFavorite